import useCallApi from '../../utilities/axios'

export type DocumentSopRequest = {
    search?: string
    /** ต้องส่งไปเสมอใส่ ? เพราะว่า form มีแบบเริ่มมาไม่มีค่าได้*/
    rec?: number | string
}

export type DownloadDocumentSopRequest = {
    sumittedTypeID?: number
    rec?: number | string
}

export type DocumentSop = {
    id: number
    nameTh: string
    nameEn: string
    files: PreviewDocument[]
}

export interface PreviewDocument {
    id: number
    nameTh: string
    nameEn: string
    documentTh: DocumentPath
    documentEn: DocumentPath
}

export interface DocumentPath {
    name: string
    path: string
}

export interface DocumentDownloadGuide {
    documentDownloadGuideID: number
    /**
     * ประเภทการยื่น (lut_submitted_type) ที่คำแนะนำนี้ผูกอยู่
     * มาจากตารางเชื่อม document_download_guide_2_submitted_type
     * ใช้จับคู่คำแนะนำกับ accordion ของแต่ละประเภท
     */
    projectSubmitTypeID: number | null
    topic: string
    content: { en: string; th: string }
    order: number
}

export const useResearcherDocument = () => {
    const callApi = useCallApi()

    const buildQuery = (params: Record<string, any>) => {
        const query = Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== null && value !== '')
            .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
            .join('&')

        return query ? `?${query}` : ''
    }

    const getDocumentSop = async (values: DocumentSopRequest) => {
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/document-sop${buildQuery({
                search: values.search,
                recID: values.rec,
            })}`,
        })

        return data
    }

    const getDocumentDownloadGuide = async (values: DocumentSopRequest = {}) => {
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/document-download-guide${buildQuery({
                recID: values.rec,
            })}`,
        })

        return data
    }

    const downloadDocumentSop = async (values: DownloadDocumentSopRequest) => {
        const { data } = await callApi.axiosGet({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/document-sop/download${buildQuery({
                sumittedTypeID: values.sumittedTypeID,
                recID: values.rec,
            })}`,
            config: {
                responseType: 'blob',
            },
        })

        return data
    }

    return {
        getDocumentSop,
        downloadDocumentSop,
        getDocumentDownloadGuide,
    }
}
